module.exports = __webpack_public_path__ + "static/media/drop.d4d03939.svg";